module.exports = __webpack_public_path__ + "img/9-16.a232b2c6.jpg";